/* istanbul ignore file */
import { createUseStyles } from '@glu/theming';

export default createUseStyles(({
  nav: {
    activeHighlightColor,
    horiz
  }
}) => ({
  icon: {},
  linkActive: {},
  rootActive: {
    '&::before': {
      backgroundColor: activeHighlightColor,
      content: '""',
      position: 'absolute',
      bottom: -8,
      left: 0,
      height: '8px',
      width: '100%',
      margin: 0,
      opacity: 1
    }
  },
  navLinks: {},

  item: {
    paddingBottom: horiz.borderBottomWidth,
    marginBottom: -horiz.borderBottomWidth,
    '& > $navLinks': {
      display: ({ open }) => (open ? 'block' : 'none')
    },
    '&:hover, &:focus': {
      '& > $navLinks': {
        display: ({ openOnHover }) => (openOnHover ? 'block' : undefined)
      }
    }
  },
  'tier0-item': {
    position: ({ relativePosition }) => (relativePosition ? 'relative' : 'static'),
    float: 'left'
  },
  'tier0-link': {
    fontFamily: horiz.fontFamily,
    fontSize: 18,
    fontWeight: 300,
    height: horiz.tier0.linkHeight,
    background: 'transparent',
    position: 'relative',
    border: 0,
    display: 'block',
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '& svg': {
      height: 16,
      width: 16,
      fill: horiz.tier0.linkColor,
      position: 'relative',
      top: 2
    },
    '&:hover, &:focus': {
      background: ({ shadeOnHover }) => (shadeOnHover ? horiz.tier0.linkHoverBackground : 'transparent'),
      outline: 'none'
    },
    lineHeight: `${horiz.tier0.linkHeight}px`,
    padding: [0, horiz.tier0.linkPadding],
    color: horiz.tier0.linkColor,
    '&::after': {
      content: ({ divider }) => (divider ? '""' : ''),
      opacity: 0.5,
      width: 1,
      height: 18,
      position: 'absolute',
      top: '50%',
      marginTop: -10,
      right: 0,
      marginLeft: horiz.tier0.linkPadding,
      background: horiz.tier0.linkDividerColor
    },
    '& $icon': {
      marginLeft: 10
    },
    '&$linkActive': {
      background: horiz.tier0.linkHoverBackground
    }
  },
  'tier0-children': {
    position: 'absolute',
    background: 'white',
    zIndex: 99,
    top: horiz.tier0.linkHeight + horiz.borderBottomWidth,
    left: ({ alignRight }) => (alignRight ? 'auto' : 0),
    right: ({ alignRight }) => (alignRight ? 0 : 'auto'),
    padding: [13, 0],
    boxShadow: '0px 0px 6px rgba(0,0,0,0.2)',
    minWidth: 250,
    maxWidth: 320,
    listStyleType: 'none',
    '& ul': {
      listStyleType: 'none',
      margin: [0, 0, 0, 20],
      padding: 0
    },
    '& a, & button': {
      color: horiz.tier1.linkColor,
      textAlign: 'left',
      fontFamily: horiz.fontFamily,
      fontSize: 18,
      fontWeight: 300,
      width: '100%',
      height: horiz.tier1.linkHeight,
      background: 'transparent',
      position: 'relative',
      border: 0,
      display: 'block',
      cursor: 'pointer',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      '& svg': {
        height: 16,
        width: 16,
        fill: horiz.tier1.linkColor,
        position: 'relative',
        top: 2
      },
      '&:hover, &:focus': {
        background: horiz.tier1.linkHoverBackground,
        '&::after': {
          display: 'none'
        },
        outline: 'none'
      },
      lineHeight: `${horiz.tier1.linkHeight}px`,
      padding: [0, horiz.tier1.linkPadding],
      '& $icon': {
        marginLeft: 10
      }
    },
    '& $linkActive': {
      background: horiz.tier1.linkHoverBackground
    }
  }
}));
